import Duration from '../../modules/components/Duration';

export default Duration;



// WEBPACK FOOTER //
// ./src/components/shared/Duration.js